import axios from 'axios';

export async function getUuid() {
    let uuid = localStorage.getItem('uuid');
    if (uuid) {
        try {
            await axios.get(`/submission/${uuid}/`);
        } catch (e: any) {
            if (e.status === 404) {
                localStorage.removeItem('uuid');
                const submission = await axios.post('/submission/');
                if (submission?.data?.identifier) {
                    localStorage.setItem('uuid', submission.data.identifier);
                    uuid = submission.data.identifier;
                }
            }
        }
    }

    if (!uuid) {
        const submission = await axios.post('/submission/');
        if (submission?.data?.identifier) {
            localStorage.setItem('uuid', submission.data.identifier);
            uuid = submission.data.identifier;
        }
    }

    return uuid;
}
